var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexbg"
  }, [_c('topbar'), _vm._v(" "), _c('header'), _vm._v(" "), _c('emallheader'), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-shopping-cart"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contain"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pv10 f14"
  }, [_vm._v("\n\t\t\t\t\t\t订单消费总计：\n\t\t\t\t\t\t"), (_vm.goodsTotalPrice.totalPoint > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalPoint) + "积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalRed > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalRed) + "红积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalBlue > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalBlue) + "蓝积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalSpecial > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalSpecial) + "专用积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.sumAmount > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v("¥" + _vm._s(_vm.sumAmount))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.orderList), function(order) {
    return _c('div', [_c('ul', [_c('ul', {
      staticClass: "fl w450 co5"
    }, [_c('li', {
      staticClass: "pv10"
    }, [_vm._v("订单编号：" + _vm._s(order.trade_code))]), _vm._v(" "), _c('li', {
      staticClass: "pv10"
    }, [_vm._v("交易日期：" + _vm._s(_vm.createTime))])]), _vm._v(" "), _c('ul', {
      staticClass: " fl co5"
    }, [_c('li', {
      staticClass: "pv10"
    }, [_vm._v("商品名称：" + _vm._s(order.goods_name))]), _vm._v(" "), _c('li', {
      staticClass: "pv10"
    }, [_vm._v("商品数量：" + _vm._s(order.goods_number))])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "contain mt20"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "m30"
  }, [_c('a', {
    staticClass: " w200",
    staticStyle: {
      "margin-right": "30px"
    },
    on: {
      "click": function($event) {
        _vm.payEmall('yunpay_wx', null)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/weixin_pay.png")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: " w200",
    on: {
      "click": function($event) {
        _vm.payCQ('yunpay_zfb')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/zfbzf.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "shadowLayer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-reg-step"
  }, [_c('ul', {
    staticClass: "ico"
  }, [_c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("购物车")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("提交订单")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('p', {
    staticClass: "item"
  }, [_vm._v("确认付款")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("下单成功")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-title"
  }, [_c('h5', {
    staticClass: "f18"
  }, [_vm._v("订单信息")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-title"
  }, [_c('h5', {
    staticClass: "f18"
  }, [_vm._v("支付选择")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/footer-ad-1.png"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38f3f95a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/order/orderConfirm.vue
// module id = tthr
// module chunks = 1